// extracted by mini-css-extract-plugin
module.exports = {"detail-modal":"DetailModal_detail-modal__Bgwy4"};